import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  // insert customer status setup
  insertCustomerStatusSetUp: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.post('/discount/customer-status', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // update customer status
  updateCustomerStatus: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`discount/${id}/customer-status`, data)

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return { message: res.data.message }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const message = err.response.data.meta && Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      return Promise.reject({ message })
    }
  },

  // delete customer status
  deleteCustomerStatus: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.delete(`/discount/${id}/customer-status`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return { message: res.data.message }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return Promise.reject(err.response.data)
    }
  },

  // get allcustomer status
  getSystemCustomerStatus: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    const { page, limit, search, order, type } = payload

    try {
      const res = await axios.get('/discount/customer-status', {
        params: {
          limit,
          page,
          order,
          search,
          type
        }
      })

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'customerStatus',
        data: res.data.data
      })

      return {
        data: res.data.data
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get  by  customer status
  getSystemCustomerStatusById: async (_, id) => {
    try {
      const res = await axios.get(`discount/${id}/customer-status`)
      return {
        data: res.data.customerStatus,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  }
}
